import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './index.module.less';

const Slogan: React.FC = () => (
  <div className={styles.wrapper}>
    <span><FormattedMessage id="Slogan.First" /></span>
    <br />
    <span><FormattedMessage id="Slogan.Second" /></span>
  </div>
);

export default Slogan;
